import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    getFullComposeViewState,
    getComposeEvent,
    getOriginalEvent,
} from 'owa-calendar-compose-store-manager';
import saveEventInternal from 'owa-calendar-compose-form-orchestration/lib/utils/saveEventInternal';
import { onIsDraftChanged } from 'owa-calendar-compose-form-actions';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { endAsyncDatapoint } from 'owa-calendar-data-utils/lib/endAsyncDatapoint';
import updateContentToViewState from 'owa-editor/lib/utils/updateContentToViewState';

// TODO: Needs update for multi-form
// [VSO tracking item]
let activeSaving;

export const saveItem = async (formId: string): Promise<string> => {
    if (activeSaving) {
        // wait for active save function to complete
        await activeSaving;
    }

    const event = getComposeEvent(formId);
    const originalEvent = getOriginalEvent(formId);
    const viewState = getFullComposeViewState(formId);

    if (viewState) {
        updateContentToViewState(viewState.bodyViewState);
    }

    if (originalEvent.MeetingRequestWasSent || (!originalEvent.IsMeeting && originalEvent.ItemId)) {
        return Promise.resolve(event.ItemId.Id);
    }

    onIsDraftChanged(true, formId);
    const datapoint = new PerformanceDatapoint('SaveCalendarEventDraftForAddin');

    return save(
        (saveEventInternal(datapoint, formId) as Promise<CalendarEvent>)
            .then((calendarEvent: CalendarEvent) => {
                onIsDraftChanged(false, formId);
                endAsyncDatapoint(datapoint);
                if (calendarEvent?.ItemId) {
                    return Promise.resolve(calendarEvent.ItemId.Id);
                }
                const updatedEvent = getComposeEvent(formId);
                return Promise.resolve(updatedEvent.ItemId.Id);
            })
            .catch(e => {
                datapoint.endWithError(DatapointStatus.ClientError, e);
                return Promise.resolve(null);
            })
    );
};

function save(saveEvent: Promise<string>): Promise<string> {
    activeSaving = saveEvent;
    return saveEvent
        .then(result => {
            activeSaving = null;
            return Promise.resolve(result);
        })
        .catch(error => {
            activeSaving = null;
            return Promise.reject(null);
        });
}
